import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, fileUrl } from "../lib/api";

const SettingsCtx = createContext(null);

export function SettingsProvider({ children }) {
  const [logoUrl, setLogoUrl] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setLogoUrl(data.logo_url ? fileUrl(data.logo_url) : null);
    } catch {
      setLogoUrl(null);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return <SettingsCtx.Provider value={{ logoUrl, refresh, setLogoUrl }}>{children}</SettingsCtx.Provider>;
}

export function useSettings() {
  const ctx = useContext(SettingsCtx);
  if (!ctx) throw new Error("useSettings must be within SettingsProvider");
  return ctx;
}
